import React from 'react';
import { ChatCard,ImgCoordinadora } from '../atoms';
import { Typography, Box, WithStyles, withStyles } from '@material-ui/core';
import { chatListaStyles } from '../../styles';
import { connect } from 'react-redux';
import { IGuia } from '../../interface/IGuia';

interface ChatListaProp extends WithStyles<typeof chatListaStyles> {
    guia:IGuia
    children?: React.ReactNode;
    className?: string;
    notificaciones: number;
}
export const ChatListaComponent = (props:ChatListaProp): JSX.Element => {
    const classes = props.classes
    return (
        <Box className={classes.div}>
            <ImgCoordinadora/>
            <Box>
                <Box marginTop="7%" color="#3A3B3D" fontSize={16}>
                    ¡Hola {props.guia.nombre_destinatario}!
                </Box>
                <Box marginBottom="7%" color="#979899" fontSize={13}>
                    Estas guias estan asociadas a tu celular:
                </Box>
            </Box>
            <ChatCard guia={props.guia} notificaciones={props.notificaciones}/>
        </Box>
    )
}


const mapStateToProps = (state:any) => {
    return {
      guia: state.guiasReducer,
    }
  }
  
  const mapDispatchToProps = () => ({})
  
  
  export const ChatLista = withStyles(chatListaStyles)(connect(mapStateToProps,mapDispatchToProps)(ChatListaComponent))